/**
 * The gutter every centred page sits on, from `md` up.
 *
 * `CenteredAuthenticatedLayout` only supplies the centred measure (a `Container`
 * with its own 24px gutter); the inset that actually positions the content is
 * the screen's own. Templates set it first — 40px sides, 32px above, 48px below
 * — and Web Forms, Sign Requests and Contacts followed, so those values are the
 * house style and live here rather than being re-typed per screen.
 *
 * Deliberately `md`-only: below that, each screen carries the gutters its own
 * phone/tablet reference draws (14/16px on a phone, 26px on the tablet), so
 * this must not overwrite them.
 */
export const centeredPage = {
  paddingTop: "32px",
  paddingX: "40px",
  paddingBottom: "48px",
} as const;

/**
 * Drop-in `sx` for a screen whose page wrapper has no responsive padding of its
 * own yet — it adds the desktop gutter and leaves every smaller viewport alone.
 *
 * `as const`, not `as SxProps<Theme>`: a screen that needs to merge this with
 * other props has to spread it, and spreading `SxProps` into an object literal
 * is a TS2769.
 */
export const centeredPageGutterSx = {
  pt: { xs: 0, md: centeredPage.paddingTop },
  px: { xs: 0, md: centeredPage.paddingX },
  pb: { xs: 0, md: centeredPage.paddingBottom },
} as const;

export default centeredPage;
